import { SummaryTitle as Container } from './styles'

export function SummaryTitle({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
